/*!

=========================================================
* Paper Kit React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components

// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader.js";
import DemoFooter from "components/Footers/DemoFooter.js";

// index sections
import SectionButtons from "views/examples/index-sections/SectionButtons.js";
import SectionNavbars from "views/examples/index-sections/SectionNavbars.js";
import SectionNavigation from "views/examples/index-sections/SectionNavigation.js";
import SectionProgress from "views/examples/index-sections/SectionProgress.js";
import SectionNotifications from "views/examples/index-sections/SectionNotifications.js";
import SectionTypography from "views/examples/index-sections/SectionTypography.js";
import SectionJavaScript from "views/examples/index-sections/SectionJavaScript.js";
import SectionCarousel from "views/examples/index-sections/SectionCarousel.js";
import SectionNucleoIcons from "views/examples/index-sections/SectionNucleoIcons.js";
import SectionDark from "views/examples/index-sections/SectionDark.js";
import SectionLogin from "views/examples/index-sections/SectionLogin.js";
import SectionExamples from "views/examples/index-sections/SectionExamples.js";
import SectionDownload from "views/examples/index-sections/SectionDownload.js";

function ComponentGallery() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("index");
    return function cleanup() {
      document.body.classList.remove("index");
    };
  });
  return (
    <>
      <IndexNavbar />
      <IndexHeader />
      <div className="main">
        <SectionButtons />
        <SectionNavbars />
        <SectionNavigation />
        <SectionProgress />
        <SectionNotifications />
        <SectionTypography />
        <SectionJavaScript />
        <SectionCarousel />
        <SectionNucleoIcons />
        <SectionDark />
        <SectionLogin />
        <SectionExamples />
        <SectionDownload />
        <DemoFooter />
      </div>
    </>
  );
}

export default ComponentGallery;
